import { create } from 'zustand';
import { getActiveLLMConfig } from '../services/llmApi';

interface LLMConfig {
  provider: string;
  name: string;
  baseUrl: string;
  model: string;
  apiKey: string;
}

interface LLMStore {
  config: LLMConfig | null;
  isLoading: boolean;
  loadConfig: () => Promise<void>;
  setConfig: (config: LLMConfig) => void;
}

export const useLLMStore = create<LLMStore>((set, get) => ({
  config: null,
  isLoading: false,

  loadConfig: async () => {
    console.log('[LLM STORE] loadConfig called');
    set({ isLoading: true });
    try {
      console.log('[LLM STORE] Calling getActiveLLMConfig API...');
      const response = await getActiveLLMConfig();
      console.log('[LLM STORE] API response:', response);

      if (response.success && response.data) {
        console.log('[LLM STORE] Setting config:', {
          provider: response.data.provider,
          name: response.data.name,
          baseUrl: response.data.baseUrl,
          model: response.data.model,
          hasApiKey: !!response.data.apiKey,
          usePlatformDefault: response.usePlatformDefault
        });
        set({ config: response.data });
      } else {
        console.warn('[LLM STORE] API returned unsuccessful:', response);
      }
    } catch (error) {
      console.error('[LLM STORE] Failed to load LLM config:', error);
    } finally {
      set({ isLoading: false });
    }
  },

  setConfig: (config) => {
    set({ config });
  }
}));
